import { create } from 'zustand';

// Simple state management without external dependencies
// Using React's built-in state patterns

export const useCartStore = create((set, get) => ({
  items: [],
  
  addItem: (product, quantity = 1, size = null, color = null) => {
    const items = get().items;
    const existingIndex = items.findIndex(
      (item) => item.product.id === product.id && item.size === size && item.color === color
    );
    
    if (existingIndex >= 0) {
      const newItems = [...items];
      newItems[existingIndex].quantity += quantity;
      set({ items: newItems });
    } else {
      set({ items: [...items, { product, quantity, size, color }] });
    }
  },
  
  removeItem: (index) => {
    const items = get().items;
    set({ items: items.filter((_, i) => i !== index) });
  },
  
  updateQuantity: (index, quantity) => {
    if (quantity <= 0) {
      get().removeItem(index);
      return;
    }
    const items = get().items;
    const newItems = [...items];
    newItems[index].quantity = quantity;
    set({ items: newItems });
  },
  
  clearCart: () => set({ items: [] }),
  
  getTotal: () => {
    return get().items.reduce((sum, item) => sum + item.product.price * item.quantity, 0);
  },
  
  getItemCount: () => {
    return get().items.reduce((sum, item) => sum + item.quantity, 0);
  },
}));
